import React, { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HomeIcon from "@mui/icons-material/Home";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import MenuIcon from "@mui/icons-material/Menu";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import SettingsIcon from "@mui/icons-material/Settings";
import { useGetPlatformsQuery } from "state/rtkQuery/platform/platformQueries";
import { useGetUsersByOrgAndStatusQuery } from "state/rtkQuery/user/userQueries";

import "./AdminNavBar.css";

const AdminNavBar = () => {
  const { orgId } = useParams();
  const sideMenuRef = React.useRef(null);
  const sideMenuContainerRef = React.useRef(null);
  const [openOrgHistorySubMenu, setOpenOrgHistorySubMenu] = useState(false);

  const [openSideMenu, setOpenSideMenu] = useState(false);

  const permissions = useSelector((state) =>
    state.auth.permissions.find((obj) => obj?.orgId === orgId)
  );

  // fix sidebar when scrolling down
  window.onscroll = () => {
    if (sideMenuRef.current) {
      if (
        document.body.scrollTop > 60 ||
        document.documentElement.scrollTop > 60
      ) {
        sideMenuRef.current.style.position = "fixed";
        sideMenuRef.current.style.top = "0";
      } else {
        sideMenuRef.current.style.position = "relative";
      }
    }
  };

  // Fetch pending approval count for to populate pending approvals badge

  // RTK Query to get platform data
  const { data: platformData, isSuccess: isPlatformDataSuccess } =
    useGetPlatformsQuery();

  // RTK Query to get users by org and status
  const { data: orgRequestsData } = useGetUsersByOrgAndStatusQuery(
    {
      orgId: orgId,
      status: "Pending",
      platformId: platformData?._id,
      perPage: 10,
      page: 1,
    },
    { skip: !isPlatformDataSuccess, pollingInterval: 300000 }
  );

  return (
    <div
      className={`sidebar-container ${openSideMenu ? "open" : ""}`}
      ref={sideMenuContainerRef}
    >
      <div
        className={`sidebar ${openSideMenu ? "open" : ""}`}
        ref={sideMenuRef}
      >
        <div className="logo-details">
          <i className="logo_icon">
            <AdminPanelSettingsIcon />
          </i>
          <div className="logo_name">Admin Dashboard</div>
          <i
            className="bx bx-menu"
            id="btn"
            onClick={() => setOpenSideMenu(!openSideMenu)}
          >
            {openSideMenu ? <MenuIcon /> : <MenuIcon />}
          </i>
          <span className="tooltip">Expand</span>
        </div>
        <hr style={{ width: "100%", color: "white", marginTop: "5px" }}></hr>
        <ul className="nav-list">
          <li>
            <NavLink
              className={({ isActive }) =>
                ["admin-nav-links", isActive ? "admin-links-active" : ""].join(
                  " "
                )
              }
              to={`/dashboard`}
            >
              <i className="bx bx-grid-alt">
                <HomeIcon />
              </i>
              <span className="links_name">Home</span>
            </NavLink>
            <span className="tooltip">Home</span>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                ["admin-nav-links", isActive ? "admin-links-active" : ""].join(
                  " "
                )
              }
              to={`/admin/${orgId}/dashboard`}
            >
              <i className="bx bx-grid-alt">
                <PendingActionsIcon />
              </i>
              <span className="links_name">Pending Approvals</span>
              <span className="links_notifications">
                {orgRequestsData?.total || 0}
              </span>
            </NavLink>
            <span className="tooltip">Pending Approvals</span>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                ["admin-nav-links", isActive ? "admin-links-active" : ""].join(
                  " "
                )
              }
              to={`/admin/${orgId}/history`}
            >
              <i className="bx bx-grid-alt">
                <ManageHistoryIcon />
              </i>
              <span className="links_name">Org History</span>
            </NavLink>
            {/* <span
                className="sub-menu-icon"
                onClick={(e) => {
                  console.log("subnav flicked!");
                  e.stopPropagation();
                  setOpenOrgHistorySubMenu(!openOrgHistorySubMenu);
                }}
              >
                <KeyboardArrowDownIcon />
              </span> */}
            <span className="tooltip">Org History</span>
            {openOrgHistorySubMenu && (
              <ul className="nav-list">
                <li>
                  <NavLink
                    className={({ isActive }) =>
                      [
                        "admin-nav-links",
                        "admin-sub-links",
                        isActive ? "admin-links-active" : "",
                      ].join(" ")
                    }
                    to={`/admin/${orgId}/history/joined`}
                  >
                    <span className="links_name">Joined History</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) =>
                      [
                        "admin-nav-links",
                        "admin-sub-links",
                        isActive ? "admin-links-active" : "",
                      ].join(" ")
                    }
                    to={`/admin/${orgId}/history/revoked`}
                  >
                    <span className="links_name">Removed History</span>
                  </NavLink>
                </li>
              </ul>
            )}
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                ["admin-nav-links", isActive ? "admin-links-active" : ""].join(
                  " "
                )
              }
              to={`/admin/${orgId}/inactive-users`}
            >
              <i className="bx bx-grid-alt">
                <PersonOffIcon />
              </i>
              <span className="links_name">Inactive Users</span>
            </NavLink>
            <span className="tooltip">Inactive Users</span>
          </li>
          <li>
            <NavLink
              className={({ isActive }) =>
                ["admin-nav-links", isActive ? "admin-links-active" : ""].join(
                  " "
                )
              }
              to={`/admin/${orgId}/copilot-dashboard`}
            >
              <i className="bx bx-grid-alt">
                <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#ffffff"><path d="M23.922 16.997C23.061 18.492 18.063 22.02 12 22.02 5.937 22.02.939 18.492.078 16.997A.641.641 0 0 1 0 16.741v-2.869a.883.883 0 0 1 .053-.22c.372-.935 1.347-2.292 2.605-2.656.167-.429.414-1.055.644-1.517a10.098 10.098 0 0 1-.052-1.086c0-1.331.282-2.499 1.132-3.368.397-.406.89-.717 1.474-.952C7.255 2.937 9.248 1.98 11.978 1.98c2.731 0 4.767.957 6.166 2.093.584.235 1.077.546 1.474.952.85.869 1.132 2.037 1.132 3.368 0 .368-.014.733-.052 1.086.23.462.477 1.088.644 1.517 1.258.364 2.233 1.721 2.605 2.656a.841.841 0 0 1 .053.22v2.869a.641.641 0 0 1-.078.256Zm-11.75-5.992h-.344a4.359 4.359 0 0 1-.355.508c-.77.947-1.918 1.492-3.508 1.492-1.725 0-2.989-.359-3.782-1.259a2.137 2.137 0 0 1-.085-.104L4 11.746v6.585c1.435.779 4.514 2.179 8 2.179 3.486 0 6.565-1.4 8-2.179v-6.585l-.098-.104s-.033.045-.085.104c-.793.9-2.057 1.259-3.782 1.259-1.59 0-2.738-.545-3.508-1.492a4.359 4.359 0 0 1-.355-.508Zm2.328 3.25c.549 0 1 .451 1 1v2c0 .549-.451 1-1 1-.549 0-1-.451-1-1v-2c0-.549.451-1 1-1Zm-5 0c.549 0 1 .451 1 1v2c0 .549-.451 1-1 1-.549 0-1-.451-1-1v-2c0-.549.451-1 1-1Zm3.313-6.185c.136 1.057.403 1.913.878 2.497.442.544 1.134.938 2.344.938 1.573 0 2.292-.337 2.657-.751.384-.435.558-1.15.558-2.361 0-1.14-.243-1.847-.705-2.319-.477-.488-1.319-.862-2.824-1.025-1.487-.161-2.192.138-2.533.529-.269.307-.437.808-.438 1.578v.021c0 .265.021.562.063.893Zm-1.626 0c.042-.331.063-.628.063-.894v-.02c-.001-.77-.169-1.271-.438-1.578-.341-.391-1.046-.69-2.533-.529-1.505.163-2.347.537-2.824 1.025-.462.472-.705 1.179-.705 2.319 0 1.211.175 1.926.558 2.361.365.414 1.084.751 2.657.751 1.21 0 1.902-.394 2.344-.938.475-.584.742-1.44.878-2.497Z"/></svg>
              </i>
              <span className="links_name">Copilot Dashboard</span>
            </NavLink>
            <span className="tooltip">Copilot Dashboard</span>
          </li>
          {permissions?.userType === "Owner" && (
            <li>
              <NavLink
                className={({ isActive }) =>
                  [
                    "admin-nav-links",
                    isActive ? "admin-links-active" : "",
                  ].join(" ")
                }
                to={`/admin/${orgId}/settings`}
              >
                <i className="bx bx-grid-alt">
                  <SettingsIcon />
                </i>
                <span className="links_name">Org Settings</span>
              </NavLink>
              <span className="tooltip">Org Settings</span>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default AdminNavBar;
